import { Calculator, Menu, X } from 'lucide-react';
import { Link } from 'react-router-dom';

export function Navbar({ menuOpen, onToggleMenu }) {
  return (
    <header className="sticky top-0 z-40 border-b border-slate-200 bg-white/95 backdrop-blur">
      <div className="mx-auto flex max-w-[1600px] items-center justify-between gap-4 px-4 py-3">
        <div className="flex items-center gap-3">
          <button
            type="button"
            className="rounded-lg p-2 text-slate-700 lg:hidden"
            onClick={onToggleMenu}
            aria-label="Toggle menu"
          >
            {menuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
          <Link to="/" className="flex items-center gap-2 font-bold text-blue-600">
            <Calculator className="h-8 w-8" />
            <span className="hidden sm:inline">AI Accountant</span>
          </Link>
        </div>
        <Link
          to="/"
          className="text-sm font-medium text-slate-600 hover:text-blue-600"
        >
          Marketing site
        </Link>
      </div>
    </header>
  );
}
